// Shared placeholder rendered by tabs that aren't built yet.
// Each consumer wraps it with its title + the phase it's coming in.

export function StubTab({ title, phase, hint }) {
  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-10 text-center">
      <div className="text-[11px] uppercase tracking-wider text-bullogic-blue font-bold mb-3">
        Coming in Phase {phase}
      </div>
      <h2 className="text-[20px] font-bold text-navy mb-3">{title}</h2>
      <p className="text-[13px] text-[#666] max-w-xl mx-auto leading-relaxed">
        {hint}
      </p>
    </div>
  );
}
